<button type="button" class="scroll-button" aria-label="Scroll to top" i18n-aria-label (click)="buttonClicked.emit()">
  <img
    [src]="'assets/icons/primary/ChevronUp.svg'"
    alt=""
    height="20"
    width="20"
    [style.height.rem]="1.25"
    [style.width.rem]="1.25" />
</button>
